import { render, staticRenderFns } from "./accidents.vue?vue&type=template&id=5a1f4532&scoped=true&"
import script from "./accidents.vue?vue&type=script&lang=js&"
export * from "./accidents.vue?vue&type=script&lang=js&"
import style0 from "./accidents.vue?vue&type=style&index=0&id=5a1f4532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1f4532",
  null
  
)

export default component.exports